/* eslint-disable */
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages1 = {};
const messages = {};

export default new VueI18n({
        locale: '1', // set locale    
        fallbackLocale: '1', // set fallback locale    
        messages, // set locale messages
    })


// WEBPACK FOOTER //
// ./src/plugins/i18n.js